import {
    BopisStoreStatus,
    getInventoryStatusLabel,
    getInventoryStatusTone,
    SELECT_STORE_STATUS_TEXT,
    validateStockStatus,
} from '@libs/shared-ui';

import type { BopisStoreStatusContentProps } from '../../model/deliveryTypes';

export const BopisStoreStatusContent = ({
    isLoading,
    storeDetails,
    availableStock,
    minimumCaseQty,
}: BopisStoreStatusContentProps) => {
    const hasStore = Boolean(storeDetails?.name);
    const stockStatus =
        !isLoading && hasStore
            ? validateStockStatus({
                  stockQuantity: availableStock,
                  minimumCaseQty,
              })
            : undefined;

    return (
        <BopisStoreStatus
            isLoading={isLoading}
            storeDetails={storeDetails}
            label={stockStatus ? getInventoryStatusLabel(stockStatus) : SELECT_STORE_STATUS_TEXT}
            tone={stockStatus ? getInventoryStatusTone(stockStatus) : undefined}
        />
    );
};
